import React from 'react';
import { theme } from '../../config/theme';

const TabSwitcher = ({ activeTab, onTabChange, tabs }) => {
  const containerStyles = {
    display: 'flex',
    borderBottom: `1px solid ${theme.colors.gray[200]}`,
    marginBottom: theme.spacing['2xl'],
  };

  const tabStyles = (isActive) => ({
    flex: 1,
    padding: `${theme.spacing.md} ${theme.spacing.lg}`,
    fontSize: theme.typography.fontSize.base,
    fontWeight: theme.typography.fontWeight.medium,
    color: isActive ? theme.colors.primary.main : theme.colors.text.secondary,
    background: 'none',
    border: 'none',
    borderBottom: `2px solid ${isActive ? theme.colors.primary.main : 'transparent'}`,
    cursor: 'pointer',
    transition: theme.transitions.base,
    fontFamily: theme.typography.fontFamily,
  });

  return (
    <div style={containerStyles}>
      {tabs.map((tab) => (
        <button
          key={tab.value}
          onClick={() => onTabChange(tab.value)}
          style={tabStyles(activeTab === tab.value)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default TabSwitcher;